import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11506c38"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Simulação de Produção", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Explodir Necessidades", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar Simulação", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda" }
const _hoisted_7 = { class: "grades-container" }
const _hoisted_8 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda grade-card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Itens para Simulação", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda grade-card" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Necessidades Calculadas", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  class: "ss-margin-top-md",
  style: {"text-align":"right","padding-top":"16px","border-top":"1px solid #f0f0f0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icone = _resolveComponent("Icone")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_selecionar_tipo_producao = _resolveComponent("selecionar-tipo-producao")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_selecionar_engenharia_producao = _resolveComponent("selecionar-engenharia-producao")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    centered: "",
    width: "80%",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    "wrap-class-name": "ss-modal-pcp",
    maskClosable: false
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_Icone, { nome: "voltar" })
    ]),
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      (_ctx.state.simulacao.codigo > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ant-btn ss-btn-impressao",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimirSimulacao()))
          }, [
            _createVNode(_component_Icone, { nome: "imprimir" })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.explodirNecessidades()))
      }, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvarSimulacao()))
      }, _hoisted_5)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 15 }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_form, {
              model: _ctx.state.simulacao,
              layout: "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: [16, 0] }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: 24,
                      sm: 12,
                      md: 8,
                      lg: 8,
                      xl: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { label: "Descrição" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.state.simulacao.descricao,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.simulacao.descricao) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: 24,
                      sm: 12,
                      md: 8,
                      lg: 8,
                      xl: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { label: "Data Simulação" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formattedDataSimulacao,
                              disabled: true
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: 24,
                      sm: 12,
                      md: 8,
                      lg: 8,
                      xl: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { label: "Observação" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.state.simulacao.observacao,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.simulacao.observacao) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, { gutter: [16, 0] }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: 24,
                      sm: 12,
                      md: 8,
                      lg: 8,
                      xl: 8
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { label: "Explosão Completa (Recursiva)" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_switch, {
                              checked: _ctx.state.simulacao.profundidadeTotal,
                              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.simulacao.profundidadeTotal) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.state.simulacao.profundidadeTotal)
                      ? (_openBlock(), _createBlock(_component_a_col, {
                          key: 0,
                          xs: 24,
                          sm: 12,
                          md: 8,
                          lg: 8,
                          xl: 8
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "Tipo de Produção (PI)" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_producao, {
                                  codigoSelecionado: _ctx.state.simulacao.codigoTipoProducaoPI,
                                  "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.simulacao.codigoTipoProducaoPI) = $event)),
                                  empresas: [_ctx.state.simulacao.codigoEmpresa],
                                  placeholder: "Selecione o tipo de produção"
                                }, null, 8, ["codigoSelecionado", "empresas"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_a_row, {
                gutter: [16, 0],
                class: "ss-margin-bottom-sm",
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 14
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "Produto",
                        labelCol: { span: 24 },
                        wrapperCol: { span: 24 }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_engenharia_producao, {
                            style: {"width":"100%"},
                            "codigo-selecionado": _ctx.state.novoItem.codigoEngenharia,
                            "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.novoItem.codigoEngenharia) = $event)),
                            descricaoSelecionado: _ctx.state.novoItem.descricaoProduto,
                            "onUpdate:descricaoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.novoItem.descricaoProduto) = $event)),
                            empresas: [_ctx.state.simulacao.codigoEmpresa],
                            placeholder: "Digite para buscar uma engenharia...",
                            limparSelecao: true,
                            tipoProducao: 0
                          }, null, 8, ["codigo-selecionado", "descricaoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 6
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "Quantidade",
                        labelCol: { span: 24 },
                        wrapperCol: { span: 24 }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            valor: _ctx.state.novoItem.quantidadeSimulada,
                            "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.novoItem.quantidadeSimulada) = $event)),
                            quantidadeCasasDecimais: 4,
                            style: {"width":"100%"}
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 4,
                    style: {"display":"flex","align-items":"flex-end"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "",
                        style: {"margin-top":"24px","margin-bottom":"0"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            class: "ant-btn ant-btn-primary",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.adicionarItem())),
                            icone: "adicionar"
                          }, _hoisted_11)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_table, {
                columns: _ctx.colunasItens,
                "data-source": _ctx.state.simulacao.itensSimulados,
                rowKey: "codigoEngenharia",
                size: "small",
                pagination: false
              }, {
                bodyCell: _withCtx(({ column, record, text }) => [
                  (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 4)), 1))
                    : _createCommentVNode("", true),
                  (column.key === 'acoes')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.removerItem(record))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "data-source"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_a_table, {
                columns: _ctx.colunasNecessidades,
                "data-source": _ctx.state.simulacao.necessidadesCalculadas,
                rowKey: "codigoProduto",
                size: "small",
                pagination: false
              }, {
                bodyCell: _withCtx(({ column, text }) => [
                  (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 4)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "data-source"]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("strong", null, "Custo Total Necessário: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.custoTotalNecessario, 2)), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible"]))
}